import { v2_parcelSearchParameters } from '@lanterds/types';
import { baseUrl, genericNetworkErrorHandler } from '.';
import { AuthRequest, Method } from 'src/util/Request';

export const postParcelsSearch = async (searchParams: Partial<v2_parcelSearchParameters>) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    const url = `${baseUrl}/v2/parcelSearch/parcels`;

    const { parcelCode, partNumber, startDate, endDate, endpoint, customerId, manifestNumber, sortDirection, sortBy } =
        searchParams;

    const body: v2_parcelSearchParameters = {
        parcelCode,
        partNumber,
        startDate: startDate ? new Date(startDate) : undefined,
        endDate: endDate ? new Date(new Date(endDate).getTime() + 1000 * 60 * 60 * 24 - 1) : undefined, // Add 1 day to the end date
        endpoint,
        customerId,
        manifestNumber,
        sortDirection,
        sortBy,
    };

    const res = await AuthRequest(url, Method.POST, headers, body);
    if (res.ok) {
        const parcels = await res.json();
        return parcels;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getParcelDetails = async (barcode: string, date: Date, customerId: string) => {
    const encCustomer = encodeURIComponent(customerId);
    const encBarcode = encodeURIComponent(barcode);
    const encDate = encodeURIComponent(date.toISOString());

    const url = `${baseUrl}/v2/parcelSearch/details/getDetailsByUniversalID/${encCustomer}/${encBarcode}/${encDate}`;

    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const details = await res.json();

        return details;
    } else {
        await genericNetworkErrorHandler(res);
    }
};
